import Chip from '@mui/material/Chip';
import styled from 'styled-components';
import { theme } from '../../../theme';

const { orangeAccent } = theme.palette.custom;

export const OrangeRatingChip = styled(Chip)`
  border: 1px solid ${orangeAccent};
  color: ${orangeAccent};
`;
